import {getFunctions, httpsCallable} from 'firebase/functions'
import React, {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {Redirect} from 'react-router-dom'
import {myFirebase} from '../firebase/firebase'
import {RootState} from '../store'
import {setDerivedPropertiesForItem} from '../store/items'
import {GriffonDatabaseItem, GriffonItem} from '../store/types'
import {itemMetaString} from '../utils'
import ItemDescription from './ItemDescription'
import Layout from './Layout'

export default function TextLedger() {
  const getAllItems = httpsCallable(getFunctions(myFirebase), 'getAllItems')

  const cents = useSelector(
    (state: RootState) => state.auth.user?.patreonEntitledAmountCents,
  )
  const isAdmin = useSelector((state: RootState) => state.auth.user?.isAdmin)

  const eligible = isAdmin || (cents && cents >= 300)

  if (!eligible) {
    return <Redirect to="/" />
  }

  const [items, setItems] = useState<GriffonItem[]>([])
  useEffect(() => {
    const getItems = async () => {
      const result = await getAllItems()

      return (result.data as GriffonDatabaseItem[])
        .map(item => setDerivedPropertiesForItem(item))
        .sort((a, b) => a.name.localeCompare(b.name))
      // .sort((a, b) => sortableItemDate(a).localeCompare(sortableItemDate(b)))
    }

    getItems()
      .then(docs => setItems(docs))
      .catch(e => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const err: any = e
        alert(err.message)
        console.error(err)
      })
  }, [])

  return (
    <Layout>
      <main>
        {items.map(i => (
          <BookItem key={i.id} item={i} />
        ))}
      </main>
    </Layout>
  )
}

const BookItem = ({item}: {item: GriffonDatabaseItem}) => {
  const artUrl = item.patreonArtUrl || item.patreonCardUrl
  const cardUrl = item.patreonCardUrl || item.patreonArtUrl

  const hasUrls = artUrl || cardUrl

  const date =
    item.dateYear !== undefined &&
    item.dateMonth !== undefined &&
    item.dateDay !== undefined
      ? new Date(item.dateYear, item.dateMonth, item.dateDay)
      : undefined

  return (
    <section className="mb-5">
      <h5 className="font-weight-bold">{item.name}</h5>
      <p>
        <em>{itemMetaString(item)}</em>
        {date && (
          <span>
            {' '}
            |{' '}
            {date.toLocaleDateString(undefined, {
              month: 'short',
              day: 'numeric',
            })}
          </span>
        )}
      </p>
      <ItemDescription markup={item.description} />
      {hasUrls &&
        (artUrl === cardUrl ? (
          <p>
            <a href={artUrl}>Art and Cards</a>
          </p>
        ) : (
          <>
            <p>
              <a href={artUrl}>Art</a>
              {' | '}
              <a href={cardUrl}>Cards</a>
            </p>
          </>
        ))}
    </section>
  )
}
